export default __webpack_public_path__ + "static/media/ic_mail_sm.2cc43e73.svg";